import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { ArrowLeftIcon, ArrowRightIcon } from '@ninja/icons/web';
import { getTzTimeStates, getTzDate } from '@ninja/utilities';
import styles from './DatePicker4.js';
import { checkIsValidRangeForYearHeaderView } from './utils6.js';
import { useCalendarViewContext } from './components10.js';

const YearsViewHeader = () => {
    const { updateViewState, viewState: { viewNavigate, tzDate, currentCalendar, intervalEndDate, intervalStartDate }, toDate, fromDate, isIntervalPicker, maxSelectionRangeDays, } = useCalendarViewContext();
    const { year: gregorianYear } = getTzTimeStates(tzDate);
    const { year } = getTzTimeStates(tzDate, currentCalendar);
    const startYear = year + viewNavigate - 4;
    const endYear = year + viewNavigate + 7;
    const gregorianStartYear = gregorianYear + viewNavigate - 4;
    const gregorianEndYear = gregorianYear + viewNavigate + 7;
    const startYearDate = getTzDate({ year: gregorianStartYear, month: 1, day: 1 });
    const endYearDate = getTzDate({ year: gregorianEndYear, month: 1, day: 1 });
    const { allowNextYears, allowPreviousYears } = checkIsValidRangeForYearHeaderView({
        isIntervalPicker,
        maxSelectionRangeDays,
        intervalStartDate,
        intervalEndDate,
        currentCalendar,
        startYearDate,
        toDate,
        fromDate,
        endYearDate,
    });
    return (jsxs(Fragment, { children: [jsx("div", { className: styles.navigationIconContainer(!allowPreviousYears), onClick: () => {
                    if (allowPreviousYears)
                        updateViewState({ viewNavigate: viewNavigate - 12 });
                }, children: jsx(ArrowLeftIcon, { className: styles.navigationIcon(!allowPreviousYears) }) }), jsxs("div", { children: [startYear, " - ", endYear] }), jsx("div", { className: styles.navigationIconContainer(!allowNextYears), onClick: () => {
                    if (allowNextYears)
                        updateViewState({ viewNavigate: viewNavigate + 12 });
                }, children: jsx(ArrowRightIcon, { className: styles.navigationIcon(!allowNextYears) }) })] }));
};

export { YearsViewHeader };
